var _rect, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHandyman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4223_1773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4223_1773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5484 17.8959C15.4479 17.8959 15.3545 17.8798 15.2679 17.8477C15.1813 17.8157 15.099 17.7607 15.0211 17.6827L10.8192 13.4888C10.7411 13.4107 10.6861 13.3284 10.654 13.2419C10.622 13.1554 10.6061 13.0619 10.6061 12.9615C10.6061 12.8611 10.622 12.7676 10.654 12.6811C10.6861 12.5946 10.7411 12.5123 10.8192 12.4344L12.3977 10.8559C12.4757 10.7778 12.5579 10.7227 12.6444 10.6907C12.7309 10.6587 12.8244 10.6427 12.9248 10.6427C13.0252 10.6427 13.1187 10.6587 13.2052 10.6907C13.2919 10.7227 13.3742 10.7778 13.4521 10.8559L17.654 15.0577C17.732 15.1357 17.7871 15.2179 17.8192 15.3044C17.8511 15.3911 17.8671 15.4846 17.8671 15.585C17.8671 15.6855 17.8511 15.7789 17.8192 15.8655C17.7871 15.952 17.732 16.0342 17.654 16.1121L16.0754 17.6827C15.9975 17.7607 15.9153 17.8157 15.8288 17.8477C15.7422 17.8798 15.6488 17.8959 15.5484 17.8959ZM15.5484 16.4696L16.4329 15.585L12.9377 12.0898L12.0532 12.9744L15.5484 16.4696ZM4.43128 17.9086C4.33086 17.9086 4.23523 17.8905 4.1444 17.8542C4.05371 17.8178 3.96933 17.7607 3.89128 17.6827L2.32565 16.125C2.2476 16.047 2.19044 15.9626 2.15419 15.8719C2.1178 15.7811 2.09961 15.6855 2.09961 15.585C2.09961 15.4846 2.1178 15.3898 2.15419 15.3005C2.19044 15.2113 2.2476 15.1277 2.32565 15.0496L6.67815 10.6971H8.43294L9.10919 10.0209L5.62357 6.53525H4.43607L2.12357 4.22275L4.1894 2.15712L6.5019 4.46962V5.65712L9.98732 9.14275L12.4521 6.67796L11.2359 5.4615L12.2902 4.40712H10.1686L9.70544 3.95191L12.3671 1.29004L12.8223 1.74525V3.87504L13.8767 2.82066L17.0115 5.93921C17.2315 6.15393 17.3973 6.39858 17.509 6.67316C17.6207 6.94775 17.6765 7.2383 17.6765 7.54483C17.6765 7.81414 17.63 8.07351 17.5371 8.32296C17.4442 8.5724 17.3091 8.79914 17.1317 9.00317L15.3929 7.26441L14.2182 8.43921L13.3352 7.55608L9.30315 11.5882V13.3461L4.95857 17.6827C4.88065 17.7607 4.79836 17.8178 4.71169 17.8542C4.62516 17.8905 4.53169 17.9086 4.43128 17.9086ZM4.43128 16.4615L8.25357 12.6394V11.7548H7.36878L3.54669 15.5769L4.43128 16.4615ZM4.43128 16.4615L3.54669 15.5769L3.99544 16.013L4.43128 16.4615Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandyman);
export default __webpack_public_path__ + "static/media/handyman.9845a961.svg";
export { ForwardRef as ReactComponent };